import React from "react";
import Skeleton from "react-loading-skeleton";

const SearchBarSkeleton = () => <Skeleton height={30} width={200} />;

export default SearchBarSkeleton;
